import { Notification } from '@app/components'
import {
  CSTContract,
  DaiContract,
  HexContract,
  IncContract,
  PhlpContract,
  PlsxContract,
  TestMainWaitContract,
  TestWaitContract,
  USDCContract,
  USDTContract,
  WaitContract,
  wPlsContract,
} from 'libs/data/contracts'
import { useChainId } from 'wagmi'

import useCSTBalance from './useCSTBalance'
import useWrite from './useWrite'

export default (number, func, token): any => {
  const balance = useCSTBalance(false)
  const chainId = useChainId()
  const contractAddress =
    token == 'wPLS'
      ? (wPlsContract.address as `0x${string}`)
      : token == 'PLSX'
        ? (PlsxContract.address as `0x${string}`)
        : token == 'GLORY'
          ? '0x37D16BabDce0427e63233b3d9be149B31ac2E6f8'
          : token == 'TIDE'
            ? '0xdedBCc8D9458B2556375680FbA297C6aCa6c7DCf'
            : token == 'PHLP'
              ? (PhlpContract.address as `0x${string}`)
              : token == 'INC'
                ? (IncContract.address as `0x${string}`)
                : token == 'WAIT'
                  ? process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
                    ? TestWaitContract.address
                    : chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && process.env.NEXT_PUBLIC_ENV == 'development'
                      ? TestMainWaitContract.address
                      : process.env.NEXT_PUBLIC_ENV != 'development'
                        ? WaitContract.address
                        : WaitContract.address
                  : token == 'HEX'
                    ? (HexContract.address as `0x${string}` as `0x${string}`)
                    : token == 'USDC'
                      ? (USDCContract.bridgeAddress as `0x${string}`)
                      : token == 'USDT'
                        ? (USDTContract.bridgeAddress as `0x${string}`)
                        : token == 'DAI'
                          ? (DaiContract.bridgeAddress as `0x${string}`)
                          : process.env.NEXT_PUBLIC_ENV == 'development'
                            ? '0xBf51d5fE277cCbB53B795BDaD6de2496Cbc8024F'
                            : (CSTContract.address as `0x${string}`)
  return useWrite({
    isBurn: true,
    contract: contractAddress,
    abi: CSTContract.abi,
    functionName: 'transfer',
    loading: balance.state === 'loading',
    enabled: true,
    args: [
      process.env.NEXT_PUBLIC_ENV == 'development'
        ? '0x8F62DfbF73ea9411b74303b3e1b43ff3Eb64cFD8'
        : '0x8eB135581A1c37BA0cA5bCdb43b3c0a9Dc7e5062',
      number *
        10 **
          (token == 'HEX' || token == 'WAIT'
            ? 8
            : token == 'USDC' || token == 'USDT' || token == 'CST' || token == 'GLORY'
              ? 6
              : 18),
    ],
    // Obvioulsy this needs to change
    onTransactionComplete: (burnHash: string) => {
      func(burnHash)
      if (burnHash === null) {
        Notification({
          message:
            token == 'USDC' || token == 'USDT' || token == 'CST' || token == 'DAI'
              ? 'Burn Completed! Transfer Pending'
              : 'Sell Completed! Transfer Pending',
          type: 'success',
        })
      } else {
        Notification({
          message:
            token == 'USDC' || token == 'USDT' || token == 'CST' || token == 'DAI' ? 'Burn Pending' : 'Sell Pending',
          type: 'info',
        })
      }
    },
  })
}
